import apiClient from 'apiClient';
import { CreditCheckResult as API } from './Credit';
import { CreditCheckResult as Domain } from 'modules/cm/Credit/Credit';
import { apiToDomain } from './mapper';
import axios from 'axios';
import { isCorrectResponse } from 'utils/api/error/ResponseError';
import { ExperianAPIError, ExperianCheckError } from './errors';
import isExperianError from './errors/isExperianError';

const softCheck = async (apiPrefix: string): Promise<Domain> => {
  try {
    const { data } = await apiClient.post<API>(`${apiPrefix}/soft-check`);
    return apiToDomain(data);
  } catch (error) {
    if (axios.isAxiosError(error) && isCorrectResponse<ExperianAPIError>(error.response) && isExperianError(error)) {
      throw new ExperianCheckError(error.response.data.error);
    }
    throw error;
  }
};

export default softCheck;
